export enum OpportunityLossReasons {
    SCHEDULE = 'Schedule',
    PRICE = 'Price',
    DESIGN_CHANGE = 'Design change',
    NOT_AWARDED = 'Not awarded to customer',
    NEVER_REALIZED = 'Project never realized',
    ABANDONED_EV = 'Abandoned by EV',
    ABANDONED_CUSTOMER = 'Abandoned by the customer',
    AWARDED_TO_OTHERS = 'Awarded by other supplier'
}
